export default __webpack_public_path__ + "static/media/login-video-5.c5ee8bf7.mp4";